// removed by extract-text-webpack-plugin
module.exports = {"suggestions":"theme__suggestions___Mv6xf","up":"theme__up___W8g9n"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Admin/components/CollegeView/components/AddCollege/theme.css
// module id = 1593
// module chunks = 0